/**
 * Seamly Channel API
 * The API for Seamly Channel REST API <br/><br/> **Please note**: You can view which schemas apply to an endpoint by navigating to the response of an endpoint and then clicking on *Schema*, right next to *Example Value*. By default example values are shown for each response.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@seamly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Translation } from './translation';
import { MessageIncomingPayloadTranslatedBody } from './message-incoming-payload-translated-body';
import { Actions } from './actions';
import { MessageIncomingPayloadBody } from './message-incoming-payload-body';
import { MessageIncomingPayloadEntry } from './message-incoming-payload-entry';
import { Service } from './service';
import { MessageIncomingPayloadTranslatedEntry } from './message-incoming-payload-translated-entry';

export interface MessageIncomingPayload {
    actions?: Actions | null;
    body: MessageIncomingPayloadBody;
    entry: MessageIncomingPayloadEntry | null;
    /**
     * Whether this message is sent by the user (true) or is received from a bot or agent (false).
     */
    fromClient: boolean;
    /**
     * Unique identifier of the message
     */
    id: string;
    /**
     * Status of the message: \"received\" or \"read\".
     */
    messageStatus: string;
    /**
     * Timestamp of the message in microseconds
     */
    occurredAt: number;
    /**
     * Reference to the participant of the message
     */
    participant: string | null;
    service?: Service;
    /**
     * Identifier of the transaction this message belongs to. Aids to group and link messages together. When a bot service for instance emits multiple messages at once they\'ll all have the same transactionId.
     */
    transactionId: string | null;
    /**
     * Whether or not this message is the last one in the transaction.
     */
    transactionLast: boolean | null;
    translatedActions?: Actions | null;
    translatedBody?: MessageIncomingPayloadTranslatedBody | null;
    translatedEntry?: MessageIncomingPayloadTranslatedEntry | null;
    translation?: Translation | null;
    /**
     * Type of the message body
     */
    type: MessageIncomingPayload.TypeEnum;
}
export namespace MessageIncomingPayload {
    export type TypeEnum = 'card' | 'carousel' | 'choice_prompt' | 'cta' | 'custom' | 'image' | 'splash' | 'text' | 'upload' | 'video';
    export const TypeEnum = {
        Card: 'card' as TypeEnum,
        Carousel: 'carousel' as TypeEnum,
        ChoicePrompt: 'choice_prompt' as TypeEnum,
        Cta: 'cta' as TypeEnum,
        Custom: 'custom' as TypeEnum,
        Image: 'image' as TypeEnum,
        Splash: 'splash' as TypeEnum,
        Text: 'text' as TypeEnum,
        Upload: 'upload' as TypeEnum,
        Video: 'video' as TypeEnum
    };
}
